import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading1 = makeDefaultTypographyStyled(
  'Heading1',
  'h1',
  2.48,
  1.2,
);
